<template>
  <div
    id="app"
    :class="{
      desktop: $isElectron && isMac,
    }"
  >
    <router-view />
    <ExportTip v-if="!is_mobile" />
  </div>
</template>

<script>
import DBUtil from '@utils/DBUtil'
import emitter from '@utils/eventbus.js'
import { getOsType } from '@utils/utils'
import { hotkeys } from '@utils/hotkeys'
import NetworkMonitor from '@utils/NetworkMonitor'
import cfg from '../config'
export default {
  name: 'app',
  components: {
    ExportTip: () => import('./components/ExportTip.vue'),
  },
  data() {
    return {
      onLine: true, //目前处于网络正常
      isHasInit: false, //是否已经初始化
      initTip: null, //初始化提示
      ipc: null,
      isMac: getOsType() === 'mac',
      is_mobile: this.$isMobile() || document.body.clientWidth <= 640,
    }
  },
  computed: {
    selected_tag() {
      return this.$store.state.selected_tag || this.$store.state.pinned_selected_tag
    },
    selected_source() {
      return this.$store.state.selected_source
    },
    start_date() {
      return this.$store.state.start_date
    },
    end_date() {
      return this.$store.state.end_date
    },
    type() {
      return this.$store.state.type
    },

    me() {
      return this.$store.state.me
    },
  },
  async mounted() {
    if (!this.$route.name) {
      if (!this.me) {
        this.$router.replace({ name: 'login' })
        return
      } else {
        this.$router.replace({ name: 'mine' })
      }
    }

    if (this.$route.query.memo_id) {
      // 打开memo
      this.$store.commit('setIsOpenMemo', true)
    } else {
      // 打开首页
      if (this.$route.name == 'mine') {
        this.initEventBus()
      }
      this.$store.commit('setIsOpenMemo', false)
    }

    if (this.$isElectron) {
      this.initElectronApp()
    } else {
      this.initBaiduTongji()
    }

    window.addEventListener('unhandledrejection', this.handleUnhandledrejection)
    // 监听 window.matchMedia 函数
    window.matchMedia('(prefers-color-scheme: dark)').addListener(this.handleMediaQueryChange)
    //const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    //darkModeMediaQuery.addEventListener('change', this.handleMediaQueryChange)
    //darkModeMediaQuery.matches && this.handleDark()
    this.handleNetworkStatusChange()
    const exportProgress = localStorage.getItem('exportProgress')
    const exportTotal = localStorage.getItem('exportTotal')
    if (exportProgress && exportProgress !== null) {
      this.$store.commit('setExportProgress', exportProgress)
      this.$store.commit('setExportTotal', exportTotal)
    }
  },
  methods: {
    // handle unhandledrejection
    handleUnhandledrejection(error) {
      var explorer = window.navigator.userAgent
      if (
        explorer.indexOf('Firefox') >= 0 &&
        error &&
        error.reason.name == 'DatabaseClosedError' &&
        error.reason.message.indexOf('mutation operation') >= 0
      ) {
        this.$alert(this.$t('login.firefox_hint.title'), this.$t('common.tip'), {
          confirmButtonText: this.$t('login.firefox_hint.confirm'),
          customClass: 'confirm',
        })
      }
    },

    // 构建baidu统计
    initBaiduTongji() {
      if (!document.querySelector('#hm')) {
        var _hmt = _hmt || []
        ;(function () {
          var hm = document.createElement('script')
          hm.src = 'https://hm.baidu.com/hm.js?ee5cc40ac1c090bec5489c681fd7e6d8'
          hm.id = 'hm'
          var s = document.getElementsByTagName('script')[0]
          s.parentNode.insertBefore(hm, s)
        })()
      }
    },
    // 初始化 electronApp
    initElectronApp() {
      this.initHotKeys()
      window.ipcRenderer.send('appEnvConfig', cfg)
    },
    initEventBusIfNeeded() {
      if (!this.isHasInit) {
        this.initEventBus()
      }
    },
    initEventBus() {
      this.isHasInit = true

      DBUtil.initI18n(this)

      DBUtil.checkEstimatedQuota().then(async (storageAvailable) => {
        if (!storageAvailable) {
          this.$confirm(
            this.$t('fleditor.message.estimated_quota_not_available_content'),
            this.$t('fleditor.message.estimated_quota_not_available_title'),
            {
              confirmButtonText: this.$t('fleditor.message.estimated_quota_not_available_confirm'),
              // type: 'warning',
              customClass: 'confirm',
              dangerouslyUseHTMLString: true,
              showCancelButton: false,
            },
          )
            .then(() => {
              //reload
              window.location.reload()
            })
            .catch(() => {})
        }
      })

      let params = this.queryURLParams(location.search)
      let source = ''

      if (params) source = params['source']
      if (source != 'wechat' && source != 'account') {
        console.log('sync start')
        DBUtil.sync(true)
        this.$store.dispatch('setSyncing', true)
      }

      emitter.on('sync-start', async () => {
        this.loading = true
        if (DBUtil.isInit) {
          this.initTip = this.$message({
            message: this.$t('memo_list.sync_tip'),
            duration: 0,
            offset: window.innerHeight - 100,
            customClass: 'init-tip',
            iconClass: '',
          })
        }
      })
      emitter.on('sync-finish', async () => {
        this.$store.dispatch('setSyncing', false)
        const updateMemoNum = DBUtil.updateMemoNum
        console.log('sync-finish：同步修改的MEMO数量', updateMemoNum)
        if (this.$isElectron) {
          window.ipcRenderer.send('appSync')
        }
        if (updateMemoNum) {
          setTimeout(async () => {
            DBUtil.updateMemoNum = 0
            await this.$store.dispatch('loadTags')
            await this.$store.dispatch('loadLatestTags')
            await this.$store.dispatch('loadPinnedTags')
            // await this.$store.dispatch('loadStat')
            if (this.initTip) {
              this.initTip.close()
            }
          }, 200)
        }
      })
    },
    handleMediaQueryChange(mq) {
      const themeColor = document.querySelector('[name=theme-color]')
      if (this.$store.state.theme == 'auto') {
        if (mq.matches) {
          this.handleDark()
        } else {
          document.body.removeAttribute('class', 'dark_mode')
          document.documentElement.setAttribute('data-theme', 'light')
          if (themeColor == undefined) {
            return
          }
          themeColor.setAttribute('content', '#fafafa')
        }
      }
    },
    handleDark() {
      if (this.$store.state.theme == 'light') {
        return
      }
      const themeColor = document.querySelector('[name=theme-color]')
      document.getElementsByTagName('body')[0].className = 'dark_mode'
      document.documentElement.setAttribute('data-theme', 'dark')
      if (themeColor == undefined) {
        return
      }
      themeColor.setAttribute('content', '#000000')
    },
    queryURLParams(url) {
      if (url.indexOf('?') == 0) {
        //移除第一个字符
        url = url.substr(1)
      }

      let obj = {} // 声明参数对象
      let arr = url.split('&') // 以&符号分割为数组
      for (let i = 0; i < arr.length; i++) {
        let arrNew = arr[i].split('=') // 以"="分割为数组
        obj[arrNew[0]] = arrNew[1]
      }
      return obj
    },

    async initHotKeys() {
      let HotKeys = await window.$useInfo.getItem('HotKeys')
      // 若之前用户没有设置，则使用默认的
      if (!HotKeys) {
        // 兼容之前 localStorage 中的数据
        HotKeys = localStorage.hotkeys ? JSON.parse(localStorage.hotkeys) : hotkeys
      } else {
        HotKeys = JSON.parse(HotKeys)
      }

      this.$store.commit('saveHotkeys', HotKeys)
    },
    handleNetworkStatusChange() {
      NetworkMonitor.onOnline(() => {
        console.log('NetworkMonitor.onOnline')
        // 如果现在是在线状态，且之前是离线状态，则重新同步云端
        if (DBUtil.isOffline) {
          // 重新同步云端
          DBUtil.isOffline = false
          this.$store.dispatch('setIsOnLine', true)
          DBUtil.sync()
          emitter.emit('online')
        }
      })

      NetworkMonitor.onOffline(async () => {
        console.log('NetworkMonitor.onOffline')
        // 处理离线逻辑
        DBUtil.isOffline = true
        DBUtil.isSyncing = false
        this.$store.dispatch('setIsOnLine', false)
        emitter.emit('offline')
      })
    },
  },
  beforeDestroy() {
    NetworkMonitor.destroy()
  },
  watch: {
    '$store.state.isOpenMemo': function (newVal) {
      if (newVal) {
        // 打开memo
        return
      }
      // 打开首页
      this.initEventBusIfNeeded()
    },
    '$route.name': function (newVal) {
      if (!newVal || newVal !== 'mine') {
        return
      }
      // 打开mine页面
      this.initEventBusIfNeeded()
    },
    '$store.state.me': function (newVal) {
      if (this.$store.getters.isElectron) {
        window.ipcRenderer.send('appUser', newVal)
      }
      //if (!newVal) {
      //  this.$router.replace({ name: 'login' })
      //}
    },
  },
}
</script>
<style>
@import '/public/css/page.css';
@import '/public/css/popover_menu.css';
@import '../assets/css/dark.css';

* {
  margin: 0px;
  padding: 0px;
}
body {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.el-dropdown-menu,
.el-popover {
  border: 0.5px solid var(--fuzzy-border) !important;
}

.el-divider {
  background-color: var(--hoverBg) !important;
  height: 0.5px;
}
/* .desktop,
.desktop a,
.desktop button {
  user-select: none;
  cursor: default;
} */
</style>
<style>
.init-tip {
  min-width: 100px !important;
  border-radius: 5px !important;
  backdrop-filter: blur(20px);
  background-color: rgba(73, 73, 73, 0.8) !important;
}

.init-tip i {
  display: none !important;
}

.init-tip p {
  color: #fff !important;
}

.dark_mode .init-tip {
  border-color: transparent;
}
</style>

<style lang="scss">
html {
  width: 100%;
  height: 100vh;
  --primary-background-color: #fafafa;
  --memo-hover-background-color: #dddddd;
  --card-background-color: #f8f8f8;
  --active-background-color: #efefef;
  --editor-menu-bar-bg: #ffffff;
  --focused-shadow-bg: #dddddd;
  --blurd-border-color: #e8e8e8;
  --disabledBg: rgba(0, 0, 0, 0.3);
  --textColor: #413e3b;
  --svgFill: rgba(171, 171, 174);
  --heatgrid-day-bg: #efefef;
  --heatgrid-day-color: #d3ecdd;
  --heatgrid-day-light_green-bg: #d3ecdd;
  --heatgrid-day-green-bg: #8ddeb5;
  --heatgrid-day-dark_green-bg: #55bb8e;
  --blurd-shadow-color: rgba(232, 232, 232, 0.2);
  --pro-bg: #ffffff;
  --block-h3-color: #202020;
  --block-p-color: #202020;
  --p-task-color: #000;
  --proIcon: #212f4b;
  --proPath: #fff;
  --defaultBg: #fff;
  --shareStatBg: #f8f8f8;
  --shareText: rgba(29, 28, 33, 1);
  --shareFooterLogo: #1d1c21;
  --exModalBg: #f8f8f8;
  --scrollbarThumb: rgba(0, 0, 0, 0.3);
  --iconHover: #000000;
  --bgWhite: #fff;
  --textBlack: #454545;
  --textSecondary: #212f4b;
  --textGray: #9d9d9d;
  --bgSecondWhite: #fcfcfc;
  --hoverWhiteGray: #fafafa;
  --bodyBg: #fafafa;
  --grayLight: #efefef;
  --borderGray: #dbdbdb;
  --descText: #9d9d9d;
  --BgDownloadPrompt: #fefefe;
  --underline: #323232;
  --BgTestAnnouncement: #efefef;
  --divider: #dbdbdb;
  --popupColor: #454545;
  --descColor: #9d9d9d;
  --titleColor: rgb(33, 47, 75);
  --tagHoverBg: lightgrey;
  --bgGreen: #30cf79;
  --monthPlanBorder: #30cf79;
  --mothPlanHoverBg: #f4fffa;
  --yearPlanHoverBg: #2bba6d;
  --memberPlanColor: #fff;
  --svgActiveColor: #9d9d9d;
  --svgDisableColor: #d3d3d3;
  --hoverBg: rgba(0, 0, 0, 0.05);
  --splitLineBg: lightgrey;
  --tagHoverBg: rgba(55, 53, 47, 0.08);
  --themeGreen: #55bb8e;
  --glassBg: rgba(255, 255, 255, 0.8);
  --sideLiColor: #55bb8e;
  --elImageBorder: #e6e6e6;
  --elImageBg: #fff;
  --expandHoverBg: #efefef;
  --green: #30cf79;
  --saveSvgPathColor: #ffffff;
  --greenLight: #f4fffa;
  --tagMoreActionHoverBg: rgba(0, 0, 0, 0.2);
  --elInputInnerBg: #efefef;
  --tagBg: #eef3fe;
  --tagColor: #5783f7;
  --memoContentColor: #323232;
  --editorActiveColor: #000000;
  --memoShareCardBg: #efefef;
  --light-color: #fafafa;
  --defaultBorder: #dcdfe6;
  --n-s-tips-bg: #efefef;
  --wx-review-item-border: #efefef;
  --cancel-bg: #fff;
  --cancel-border: rgba(0, 0, 0, 0.1);
  --review-btn-hover-bg: #f4fffa;
  --gray-dark: rgba(69, 69, 69, 1);
  --review-filter: rgba(255, 255, 255, 0.75);
  --glass-bg: linear-gradient(180deg, rgba(255, 255, 255, 0.75) 0%, #ffffff 100%);
  --fold-after: linear-gradient(180deg, rgba(255, 255, 255, 0.75) 0%, #ffffff 100%);
  --mark-bg: #ffffb4;
  --blockquote-bg: #efefef;
  --bubble-menu-bg: rgba(250, 250, 250, 0.5);
  --editorColor: #efefef;
  --popover-head-desc: #9d9d9d;
  --divider-bg: #dcdfe6;
  --fuzzy-border: #d9d9d9;
  --svg-disable-color: #d3d3d3;
  --glass-inner-border: #fff;
  --focus-disabled: #cecece;
  --noticeBg: #ffffff;
  --mailColor: rgba(0, 0, 0, 0.05);
  --guide-pro-title-color: #30cf79;
  --guide-pro-desc-color: #454545;
  --disabled-bg: rgba(239, 239, 239, 1);
  --bigShadow: rgba(61, 30, 30, 0.2);
  --settingHoverBg: #9d9d9d;
  --popoverShadow: rgba(0, 0, 0, 0.2);
  --reviewSettingBg: #efefef;
  --rateColor: rgba(228, 117, 113, 1);
  --logoColor: #15191c;
  --verticalLine: rgba(0, 0, 0, 0.05);
  --onboardingTipBg: #589ef8;
  --onboardingTipColor: #fff;
  --circleCloseBg: #efefef;
  --heatgridTipBg: #efefef;
  --payFeedbackColor: #454545;
  --loginBtnBorder: rgba(0, 0, 0, 0.1);
  --loginWxBg: #ffffff;
  --loginInputBg: #ffffff;
  --noticeListItemBg: #fafafa;
  --lockscreenInputBg: #ffffff;
  --dark-box-bg: #fff;
  --dark-box-border: #e2e2e2;
  --cancel-btn-bg: #fff;
  --cancel-btn-hover-bg: rgba(0, 0, 0, 0.05);
  --card-p-color: #000000;
  --share-style-active: #d9d9d9;
  --recommend-memo-bg: #fffff9;
  --recommend-memo-bg-after: linear-gradient(180deg, rgba(41, 41, 41, 0), #fffff9);
  --trayLogoText: #202020;
  --appLogoBorder: #000000;
}
html[data-theme='dark'] {
  --primary-background-color: #121212;
  --memo-hover-background-color: rgba(0, 0, 0, 0.2);
  --card-background-color: #202020;
  --active-background-color: rgba(255, 255, 255, 5%);
  --heatgrid-day-bg: #3d3d3d;
  --heatgrid-day-color: #5f5f5f;
  --heatgrid-day-light_green-bg: #475446;
  --heatgrid-day-green-bg: #5d795c;
  --heatgrid-day-dark_green-bg: #79af77;
  --editor-menu-bar-bg: #202020;
  --focused-shadow-bg: rgba(0, 0, 0, 0.2);
  --blurd-border-color: rgba(232, 232, 232, 0.2);
  --blurd-shadow-color: rgba(232, 232, 232, 0.2);
  --pro-bg: #202124;
  --p-task-color: #8f9193;
  --textColor: #9d9d9d;
  --svgFill: rgba(171, 171, 174, 0.5);
  --proIcon: rgba(255, 255, 255, 0.5);
  --proPath: #000;
  --defaultBg: #202020;
  --shareStatBg: linear-gradient(166.2deg, #1c1b20 1.09%, #1c1b21 100.68%);
  --shareText: rgba(255, 255, 255, 1);
  --shareFooterLogo: #fff;
  --exModalBg: #252729;
  --scrollbarThumb: #666666;
  --iconHover: #e3e3e3;
  --bgWhite: #2e2e2e;
  --block-h3-color: lightgray;
  --block-p-color: lightgray;
  --textBlack: #9d9d9d;
  --textSecondary: #9d9d9d;
  --textGray: #9d9d9d;
  --bgSecondWhite: #454545;
  --hoverWhiteGray: #454545;
  --bodyBg: #202124;
  --grayLight: #5f5f5f;
  --borderGray: #5f5f5f;
  --descText: grey;
  --BgDownloadPrompt: #2e2e2e;
  --underline: #9d9d9d;
  --BgTestAnnouncement: #2e2e2e;
  --divider: #0f0f0f;
  --popupColor: #6d6d6d;
  --descColor: #6d6d6d;
  --titleColor: #606266;
  --tagHoverBg: #1e1e1e;
  --bgGreen: #397354;
  --monthPlanBorder: #397354;
  --mothPlanHoverBg: rgba(57, 115, 84, 0.3);
  --yearPlanHoverBg: #2e5d44;
  --memberPlanColor: #d9d9d9;
  --svgActiveColor: #000000;
  --svgDisableColor: #d9d9d9;
  --hoverBg: rgba(255, 255, 255, 0.1);
  --splitLineBg: #6d6d6d;
  --tagHoverBg: rgba(255, 255, 255, 5%);
  --themeGreen: #395345;
  --glassBg: rgba(20, 21, 24, 0.5);
  --sideLiColor: #ffffff;
  --elImageBorder: #121212;
  --elImageBg: #454545;
  --expandHoverBg: #202124;
  --green: #397354;
  --saveSvgPathColor: #d9d9d9;
  --greenLight: #30cf79;
  --tagMoreActionHoverBg: rgba(0, 0, 0, 0.2);
  --elInputInnerBg: #2e2e2e;
  --tagBg: #3a4359;
  --tagColor: #2b88d8;
  --memoContentColor: #d9d9d9;
  --editorActiveColor: #d9d9d9;
  --memoShareCardBg: #121212;
  --dark-color: #121212;
  --defaultBorder: #121212;
  --n-s-tips-bg: #202020;
  --wx-review-item-border: rgb(18, 18, 18);
  --cancel-bg: hsla(0, 0%, 100%, 0);
  --cancel-border: #9d9d9d;
  --review-btn-hover-bg: hsla(0, 0%, 100%, 0.1);
  --gray-dark: rgba(217, 217, 217, 1);
  --review-filter: rgba(41, 41, 41, 0.75);
  --glass-bg: linear-gradient(180deg, rgba(41, 41, 41, 0.1), #202020);
  --fold-after: linear-gradient(180deg, rgba(41, 41, 41, 0), #202020);
  --mark-bg: #595947;
  --blockquote-bg: #9d9d9d;
  --bubble-menu-bg: rgba(255, 255, 255, 0.15);
  --editorColor: rgba(255, 255, 255, 0.1);
  --popover-head-desc: #6d6d6d;
  --divider-bg: #121212;
  --fuzzy-border: #000000;
  --svg-disable-color: #6d6d6d;
  --glass-inner-border: rgba(255, 255, 255, 0.1);
  --focus-disabled: #364d40;
  --noticeBg: #202020;
  --mailColor: rgba(255, 255, 255, 0.1);
  --guide-pro-title-color: #d9d9d9;
  --guide-pro-desc-color: #9d9d9d;
  --disabled-bg: rgba(255, 255, 255, 0.1);
  --bigShadow: rgba(0, 0, 0, 0.8);
  --settingHoverBg: #d9d9d9;
  --popoverShadow: rgba(0, 0, 0, 0.8);
  --reviewSettingBg: rgba(255, 255, 255, 0.1);
  --rateColor: #d9d9d9;
  --logoColor: #d9d9d9;
  --verticalLine: rgba(255, 255, 255, 0.1);
  --onboardingTipBg: #2b88d8;
  --onboardingTipColor: #d9d9d9;
  --circleCloseBg: #ffffff1a;
  --heatgridTipBg: #454545;
  --payFeedbackColor: #d9d9d9;
  --loginBtnBorder: rgba(255, 255, 255, 0.1);
  --loginWxBg: linear-gradient(0deg, #202020, #202020),
    linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1));
  --loginInputBg: linear-gradient(0deg, #202020, #202020),
    linear-gradient(0deg, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1));
  --noticeListItemBg: #121212;
  --lockscreenInputBg: transparent;
  --dark-box-bg: #252929;
  --dark-box-border: #000;
  --cancel-btn-bg: transparent;
  --cancel-btn-hover-bg: transparent;
  --card-p-color: #9d9d9d;
  --share-style-active: #3a4359;
  --recommend-memo-bg: #292823;
  --recommend-memo-bg-after: linear-gradient(180deg, rgba(41, 41, 41, 0), #292823);
  --trayLogoText: #9d9d9d;
  --appLogoBorder: #ffffff;
}
.flex {
  display: flex;
}
.justify-start {
  justify-content: flex-start;
}
.justify-between {
  justify-content: space-between;
}
.items-center {
  align-items: center;
}
.fixed {
  position: fixed;
}
.bottom-fixed {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.placeholder-transparent {
  height: 200px;
}

.el-loading-mask {
  border-radius: 10px;
}

.el-message-box__wrapper {
  z-index: 66666 !important;
}
</style>
